import React, { useEffect, useState, useRef } from 'react';
import Input from '../Components/InputForm';
import LoaderGIF from '../../../../images/JioLoader.svg';
import './CreateNewJhhIdFlow.css';
import config from '../../../../config.json'
import apiRequest from '../../../../utils/api.request';
import lodash from 'lodash';
import moment from 'moment';
import {vaccinationApiRequestBody} from '../Utils/vaccinationApiRequestBody'
import {_getErrorMessage} from "../Utils/getErrorMessage"
import VerifyOtp from '../Components/VerifyOtp';
import Thankyou from '../Components/ThankYou';
import CancelModal from '../Components/CancelModal';

const send_otp_url = config.covid_vacc_base_url + "v1/send-otp-partner/";
const resend_otp_url = config.covid_vacc_base_url + "v1/resend-otp-partner/";
const verify_create_jhh_url = config.covid_vacc_base_url + "v1/verify-create-jhh/";

const otpValidationRegex = "^[0-9]{6}$";
const _validateInput = ( input, regex) => {
  const regexTester = new RegExp(regex);
  return regexTester.test(input);
}

const CreateNewJhhIdFlow = ({ showCorporateFlow, handleUserJourneyChange, profileDetails, userInfoFromApi, t, callbackAfterOtpVerify, closeWindowOnThankYouDone=false}) => {
  const [otpReceived, _setOtpReceived] = useState(false)
  const [userInfo, _setUserInfo] = useState(userInfoFromApi);
  const [nameError, _setNameError] = useState();
  const [dateError, _setDateError] = useState();
  const [genderError, _setGenderError] = useState();
  const [phoneError, _setPhoneError] = useState();
  const [getOtpDisabled, _setGetOtpDisabled] = useState();
  const [validateOtpDisabled, _setValidateOtpDisabled] = useState(false);
  const [resendOtpDisabled, _setResendOtpDisabled] = React.useState(false);
  const [getOtpError, _setGetOtpError] = useState("");
  const [validateOtpError, _setValidateOtpError] = React.useState("");
  const [otp, _setOtp] = useState("");
  const [resendOtpCounter, _setResendOtpCounter] = useState(0);
  const [errorOtp, _setErrorOtp] = useState("");
  const [showThankYou, _setShowThanksYou] = useState(false);
  const [cancelClicked, _setCancelClicked] = useState(false);
  const createdJhhId = useRef();
  const receivedOtpId = useRef();
  const _isMounted = useRef();

  const gender_options = [
    {
      value:"1",
      label:t("EOI_MALE")
    },
    {
      value:"2",
      label:t("EOI_FEMALE")
    },
    {
      value:"",
      label:t("EOI_SELECT_GENDER")
    }
  ]

  const handleCancelClicked = () => {
    _setCancelClicked(true);
  }
  
  const handleNoClicked = () => {
    _setCancelClicked(false);
  }

  useEffect(() => {
    if (resendOtpCounter > 0) {
      _isMounted.current = setTimeout(() => {
        _setResendOtpCounter((previousOtpCounter) => previousOtpCounter - 1);
      }, 1000);
    }

    return () => {
      if (_isMounted.current) clearTimeout(_isMounted.current);
    };
  }, [resendOtpCounter]);

  useEffect(()=>{
    if(nameError || dateError || genderError || phoneError){
      _setGetOtpDisabled(true)
    }
    else{
      _setGetOtpDisabled(false)
    }
  },[nameError,dateError,genderError,phoneError])
 
  const _setNameErrorFromInput = (input) => {
    input = String(input);
    if(input.trim().length == 0){
      _setNameError("Please Enter a Valid Name")
      return true;
    }
    else{
      _setNameError()
    }
    return false;
  }
  
  const _setDateErrorFromInput = (input) => {    
    input = String(input);
    if(input.trim().length == 0 || !moment(input).utcOffset("+05:30").isValid()){
      _setDateError("Please Enter a Valid date")
      return true;
    }
    else{
      _setDateError()
      
    }
    return false;
  }

  const _setGenderErrorFromInput = (input) => {
    input = String(input);
    if(input.trim().length == 0 || ["1","2"].indexOf(input) === -1){
      _setGenderError("Please Enter a Valid Gender")
      if(userInfo.gender !== "")
      _setUserInfo((prevValue)=>{
        return {
          ...prevValue,
          gender: ""
        }
      })
      return true;
    }
    else{
      _setGenderError()
    }
    return false;    
  }

  const _setPhoneErrorFromInput = (input) => {
    const phoneNumberRegex = new RegExp('^[0-9]{10}$')
    if(!phoneNumberRegex.test(input)){
      _setPhoneError("Please Enter a Valid Phone Number")
      return true;
    }
    else{
      _setPhoneError()
    }
    return false;
  }
  
  const _handleGetOtpClicked = async () => {
    if(_setNameErrorFromInput(userInfo.name)
    ||  _setDateErrorFromInput(userInfo.date_of_birth)
    ||  _setPhoneErrorFromInput((profileDetails.source_relation !== "Self" ? userInfo.primaryPhone : userInfo.phone))
    ||  _setGenderErrorFromInput(userInfo.gender)
    )
    {
      return;
    }

    let dataObj = {
      phone: (profileDetails.source_relation !== "Self" ? userInfo.primaryPhone : userInfo.phone)
    }
    const finalDataObj = vaccinationApiRequestBody(dataObj, profileDetails)
    _setGetOtpDisabled(true)
    const apiResponse = await apiRequest(send_otp_url, finalDataObj, true);
    if(apiResponse.apiResponse == "failed"){
      _setGetOtpDisabled(false)
      _setGetOtpError(lodash.get(apiResponse, "response.data.message", "Something went wrong, please try again"))
    }
    else {
      _setGetOtpError("");
      _setGetOtpDisabled(false)
      receivedOtpId.current = apiResponse.otp_id;
      _setOtpReceived(true)
      _setResendOtpCounter(60);
    }
  }

  const _handleOtpInput = (e) => {
    if (e.target.value.match(/^[0-9]+$/) !== null || e.target.value === "") {
      _setOtp(e.target.value);
      _setErrorOtp("");
      _setValidateOtpError("");
    }
  }

  const _handleResendOtpClick = async () => {
    if(resendOtpDisabled) return;
    let dataObj = {
      "phone": (profileDetails.source_relation !== "Self" ? userInfo.primaryPhone : userInfo.phone),
      "otp_id": receivedOtpId.current
    }
    dataObj = vaccinationApiRequestBody(dataObj, profileDetails);

    _setResendOtpDisabled(true);
    const response = await apiRequest(resend_otp_url,dataObj,true);
    _setResendOtpDisabled(false);

    if(lodash.get(response,"status") !== "success") {
      _setValidateOtpError(lodash.get(response, "response.data.message", "Something went wrong, please try again"));
      return;
    }
    _setValidateOtpError("");
    receivedOtpId.current = lodash.get(response,"otp_id");
    _setResendOtpCounter(60);
  }

  const _handleProceedClick = async () => {
    if(!_validateInput(otp,otpValidationRegex)) {
      _setErrorOtp("Please enter 6 digit otp.");
      return;
    }
    
    _setErrorOtp("");
    let dataObj = {
      "gender": userInfo.gender,
      "date_of_birth":userInfo.date_of_birth,
      "phone": (profileDetails.source_relation !== "Self" ? userInfo.primaryPhone : userInfo.phone),
      "name":userInfo.name,
      "otp_details": {
        "otp_id": receivedOtpId.current,
        "otp": otp
      }
    }
    dataObj.date_of_birth = moment(dataObj.date_of_birth).format('YYYY-MM-DD');
    dataObj = vaccinationApiRequestBody(dataObj, profileDetails);
    
    _setValidateOtpDisabled(true);
    const response = await apiRequest(verify_create_jhh_url,dataObj,true);
    _setValidateOtpDisabled(false);

    if(lodash.get(response,"status") !== "success") {
      _setValidateOtpError(lodash.get(response, "response.data.message", "Something went wrong, please try again"));
      return;
    }
    createdJhhId.current = lodash.get(response,"jhh_id");
    _setValidateOtpError("");
    _setResendOtpCounter(0);
    if(callbackAfterOtpVerify){
      callbackAfterOtpVerify()
    }
    _setShowThanksYou(true)
  }

  return(
    <div>
      <div className="express-interest-question">
        <div className="express-interest-left-col">
          <h1 className="express-interest-question-heading">{t("EOI_CREATE_NEW_JIOHEALTHUB_ID")}</h1>
          <p className="express-interest-question-description">{t("EOI_CREATE_NEW_JIOHEALTHUB_ID_TEXT")}</p>
          {!showThankYou &&
            <div>
              {showCorporateFlow && 
                <div onClick={() => handleUserJourneyChange("corporate-jhh-id")} className="express-interest-link">
                  {profileDetails.source_relation === "Self" 
                    ? t("EOI_USE_EXISTING_CORPORATE_PROFILE_LINK")
                    : t("EOI_USE_EXISTING_FAMILY_PROFILE_LINK")
                  }
                </div>
              }
              <div onClick={() => handleUserJourneyChange("different-jhh-id")} className="express-interest-link">
              {t("EOI_USE_DIFFERENT_JIOHEALTHHUB_ID_LINK")}
              </div>
            </div>
          }
        </div>
        <div className="express-interest-right-col">
          <Input
            label={t("EOI_NAME")}
            type="text"
            addClassInput={`express-interest-add-input-form${otpReceived ? " disabled" : ""}`}
            addClassLabel="express-interest-profile-form-label"
            readOnly={otpReceived}
            placeholder={t("EOI_NAME_PLACEHOLDER")}
            value={userInfo.name}
            error={_getErrorMessage(nameError)}
            onChange={(e)=>{
              const nameInput = e.target.value;
              if(nameError)
                _setNameError()
              _setUserInfo((prevValue)=>{
                return {
                  ...prevValue,
                  name: nameInput
                }
              })
            }}
          />
          <Input
            type={"date"}
            label={t("EOI_DATE_OF_BIRTH")}
            addClassInput={`express-interest-add-input-form${otpReceived ? " disabled" : ""}`}
            addClassLabel="express-interest-profile-form-label"
            readOnly={otpReceived}
            placeholder={t("EOI_DATE_OF_BIRTH_PLACEHOLDER")}
            value={moment(userInfo.date_of_birth).utcOffset("+05:30").isValid() ? moment(userInfo.date_of_birth).utcOffset("+05:30").format("YYYY-MM-DD") : ''}
            maxDate={moment().utcOffset("+05:30").format("YYYY-MM-DD")}
            error={_getErrorMessage(dateError)}
            onChange={(e)=>{
              const dateInput = e.target.value
              if(dateError)
                _setDateError()
              _setUserInfo((prevValue)=>{
                return {
                  ...prevValue,
                  date_of_birth: dateInput
                }
              })
            }}
          />
          <Input
            type="text"
            label={t("EOI_PHONE_NUMBER")}
            addClassInput={`express-interest-add-input-form${(otpReceived || (profileDetails.source_relation !== "Self")) ? " disabled" : ""}`}
            addClassLabel="express-interest-profile-form-label"
            placeholder={t("EOI_PHONE_NUMBER_PLACEHOLDER")}
            readOnly={otpReceived || (profileDetails.source_relation !== "Self")}
            value={(profileDetails.source_relation !== "Self" ? userInfo.primaryPhone : userInfo.phone)}
            error={_getErrorMessage(phoneError)}
            onChange={(e)=>{
              const phoneInput = e.target.value
              if(phoneError)
                _setPhoneError()
              _setUserInfo((prevValue)=>{
                return {
                  ...prevValue,
                  phone: phoneInput
                }
              })
            }}
          />
          { (profileDetails.source_relation !== "Self") && 
            <div className="create-acc-phone-text">
              {t("EOI_PHONE_NUMBER_TEXT")}
            </div>
          }
          <Input
            label={t("EOI_GENDER")}
            type="select"
            addClassInput={`express-interest-add-input-form${otpReceived ? " disabled" : ""}`}
            addClassLabel="express-interest-profile-form-label"
            readOnly={otpReceived}
            value={userInfo.gender}
            selectOptions={gender_options}
            error={_getErrorMessage(genderError)}
            onChange={(e)=>{
              const genderInput = e.target.value
              if(genderError)
                _setGenderError()
              _setUserInfo((prevValue)=>{
                return {
                  ...prevValue,
                  gender: genderInput
                }
              })
            }}
          />
          {!otpReceived &&
          <div className="express-interest-modal-buttons">
            <Input 
              type="button" 
              addClassInput="express-interest-modal-button-no express-interest-modal-button-padding" 
              value={t("EOI_CANCEL")} 
              onClick={() => handleCancelClicked()}
            />
            <Input
              disabledValue = {getOtpDisabled}
              type="button" 
              addClassInput= {`express-interest-modal-button-yes 
              express-interest-modal-button-padding 
              ${getOtpDisabled ? "express-interest-modal-button-disabled" : ""}`}
              value={t("EOI_GET_OTP")} 
              onClick={() => _handleGetOtpClicked()} 
            />
          </div>
          }
          {(getOtpError && getOtpError.length) && <><p className="form-element-error create-acc-get-otp-error">{getOtpError}</p></>}
        </div>
      </div>
      {
        otpReceived && 
        <VerifyOtp 
          otp={otp} 
          resendOtpCounter={resendOtpCounter} 
          error={_getErrorMessage(errorOtp)} 
          validateOtpError={_getErrorMessage(validateOtpError)}
          validateOtpDisabled={validateOtpDisabled}
          resendOtpDisabled={resendOtpDisabled}
          buttonsDisabled={showThankYou} 
          _handleOtpInput={_handleOtpInput} 
          _handleResendOtpClick={_handleResendOtpClick} 
          _handleCancelClick={handleCancelClicked} 
          _handleProceedClick={_handleProceedClick} 
          t={t}
          />
      }
      {
        showThankYou &&
        <Thankyou message={t("EOI_THANK_YOU_COMPONENT_PROFILE_CREATION_TEXT")} jhhId={createdJhhId.current} _handleCancelClick={handleCancelClicked} profileDetails={profileDetails} t={t} closeWindowOnThankYouDone={closeWindowOnThankYouDone} />
      }
      {cancelClicked && <CancelModal handleNoClicked={handleNoClicked}/>}
    </div>
  )
}

export default CreateNewJhhIdFlow;